import React from 'react';
import { renderBoldText } from '../lib/helpers';

/**
 * Print-only view rendered when the URL contains `?pdf=true&analysis_id=...`.
 * Server-side PDF generation hits this view, takes a snapshot, and returns the
 * binary attachment. Keep this view minimal and print-safe (no chrome, no
 * client-side fetches besides what App.js has already loaded).
 *
 * Restyled in line with the BCM Design System — see /app/memory/BCM_Design_System.md
 */
export default function PdfModeView({ analysis, currentStep }) {
  return (
    <div className="market-analysis-results pdf-mode bg-white p-8 font-sans text-black-stallion">
      <style>{`
        @media print {
          .pdf-mode { margin: 0; padding: 20px; }
          .no-print { display: none !important; }
        }
      `}</style>

      <div className="space-y-8">
        {currentStep === 4 && analysis && (
          <div className="space-y-8">
            {analysis.market_map && analysis.market_map.executive_summary ? (
              <section className="bcm-card border-silver">
                <header className="text-center mb-8 border-b border-silver pb-6">
                  <p className="bcm-label text-paradiso mb-3">BCM Market Intelligence</p>
                  <h1 className="bcm-headline text-4xl mb-3">Executive Summary</h1>
                  <p className="bcm-caption text-paradiso">Strategic overview &amp; key insights</p>
                </header>

                <div className="bcm-body text-[0.95rem]">
                  {analysis.market_map.executive_summary.split('\n\n').map((section, sectionIndex) => (
                    <div key={sectionIndex} className="mb-8">
                      {section.split('\n').map((line, lineIndex) => {
                        const trimmedLine = line.trim();
                        if (!trimmedLine) return null;

                        if (trimmedLine.startsWith('**') && trimmedLine.endsWith('**')) {
                          return (
                            <h2
                              key={lineIndex}
                              className="bcm-subhead text-lg mt-8 mb-4 border-b border-nordic pb-2"
                            >
                              {trimmedLine.replace(/\*\*/g, '')}
                            </h2>
                          );
                        }

                        if (trimmedLine.match(/^[-•*]\s+/) || trimmedLine.match(/^\d+\.\s+/)) {
                          return (
                            <div key={lineIndex} className="flex items-start mb-4 ml-4">
                              <span className="w-1.5 h-1.5 bg-bcm-orange rounded-full mt-2.5 mr-4 flex-shrink-0" />
                              <p className="flex-1">
                                {renderBoldText(
                                  trimmedLine.replace(/^[-•*]\s+/, '').replace(/^\d+\.\s+/, '')
                                )}
                              </p>
                            </div>
                          );
                        }

                        return (
                          <p key={lineIndex} className="mb-4">
                            {renderBoldText(trimmedLine)}
                          </p>
                        );
                      })}
                    </div>
                  ))}
                </div>
              </section>
            ) : (
              <div className="bcm-card text-center text-paradiso italic">
                Executive summary not available
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
